// Svelte 5 no longer needs svelte/store imports for basic reactivity
import { modalAllowed, modalUpgradeText, showUpgradePrompt } from "@app/lib/upgradePrompt.js";
import { planLoaded } from "@app/lib/entitlements.js";
import { whenPlanReady } from "@app/store/authStore.svelte.js";

// Create reactive state for the modal (private - not exported)
export const modalState = $state({ selected: null, context: null });

// Bumped on every showModal/hideModal so a modal deferred until the plan loads doesn't open over a newer one
let requestId = 0;

// Function to show a modal. context is optional modal-specific data, e.g. { tab: "integrations" } for Options.
// A modal the plan does not include shows the upgrade prompt instead. Until the sign-in check has
// delivered the plan (e.g. an Iconik or work order link opened at startup), a gated modal waits for it
// rather than being refused.
export function showModal(modalName, context = null) {
    const id = ++requestId;
    if (!modalAllowed(modalName)) {
        if (!planLoaded()) {
            whenPlanReady().then(() => {
                if (id === requestId) showModal(modalName, context);
            });
            return;
        }
        showUpgradePrompt(modalUpgradeText(modalName));
        return;
    }
    modalState.context = context;
    modalState.selected = modalName;
}

// Function to hide the modal
export function hideModal() {
    requestId++;
    modalState.selected = null;
    modalState.context = null;
}
